// src/components/biometrics/mappers.ts
import { format, isValid, parseISO } from "date-fns";
import { ApiBiometricsResponse, UiBiometricsData } from "../types/types";
import { IBiometricsData } from "../../../shared/services/api/analysis/types/biometrics";

export const isError = (v: unknown): v is Error => v instanceof Error;

// aceita payload novo com ou sem faceData
export const isApiBiometricsResponse = (v: unknown): v is ApiBiometricsResponse =>
	!!v && typeof v === "object" && "result" in (v as any) && ("platformId" in (v as any) || "faceData" in (v as any));

/** Remove ruídos tipo "Garantti informa:" do texto */
export function sanitizeMessage(msg?: string | null): string | null {
	if (!msg) return null;
	return msg.replace(/^garantti informa:\s*/i, "").trim();
}

/** Formata ISO -> dd/MM/yyyy às HH:mm (ou "—") */
export function formatDateTime(dateString?: string | null): string {
	if (!dateString) return "—";
	const d = parseISO(dateString);
	if (!isValid(d)) return "—";
	return format(d, "dd/MM/yyyy 'às' HH:mm");
}

/** Novo payload -> UI */
export function mapApiToUi(api: ApiBiometricsResponse): UiBiometricsData {
	const r = api.result ?? ({} as ApiBiometricsResponse["result"]);
	const f = api.faceData ?? ({} as NonNullable<ApiBiometricsResponse["faceData"]>);
	return {
		photoUrl: f?.arquivo ?? null,
		name: null,
		birthDate: null,
		documentNumber: null,
		similarityScore: null,
		requestDate: r.createdAt ?? null,
		captureDate: r.authenticatedAt ?? r.updatedAt ?? null,
		status: r.status ?? null,
		integratorStatus: r.integratorStatus ?? null,
		message: sanitizeMessage(r.message ?? null),
		shortUrl: r.urlShort ?? null,
		phone: f?.register_phone ?? null,
		email: f?.register_email ?? null,
		gateway: r.gateway ?? null,
		id: r.id ?? null,
		analysisId: r.analysisId ?? null,
	};
}

/** Legado -> UI (ajuste caso seu IBiometricsData real tenha outros nomes) */
export function mapLegacyToUi(bio: IBiometricsData): UiBiometricsData {
	const b: any = bio;
	return {
		photoUrl: b.photoUrl ?? b.arquivo ?? b.documentImageUrl ?? null,
		name: b.name ?? null,
		birthDate: b.birthDate ?? null,
		documentNumber: b.documentNumber ?? b.cpf ?? null,
		similarityScore: typeof b.similarityScore === "number" ? b.similarityScore : null,
		requestDate: b.requestDate ?? b.createdAt ?? null,
		captureDate: b.captureDate ?? b.authenticatedAt ?? b.updatedAt ?? null,
		status: b.status ?? null,
		integratorStatus: b.integratorStatus ?? null,
		message: sanitizeMessage(b.message ?? null),
		shortUrl: b.urlShort ?? null,
		phone: b.phone ?? b.register_phone ?? null,
		email: b.email ?? b.register_email ?? null,
		gateway: b.gateway ?? null,
		id: b.id ?? null,
		analysisId: b.analysisId ?? null,
	};
}
